var React = require('react');

function Success (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_10","data-name":"Ellipse 10","cx":"12","cy":"12","r":"12","fill":"#fff","key":0}),React.createElement("path",{"id":"Tick","d":"M37.018,30.625l-8.686,8.716-3.844-3.857a1.222,1.222,0,0,0-1.725,1.731l4.691,4.707a1.193,1.193,0,0,0,.847.364,1.143,1.143,0,0,0,.847-.364l9.5-9.536a1.213,1.213,0,0,0,0-1.731A1.121,1.121,0,0,0,37.018,30.625Z","transform":"translate(-18.4 -24.287)","fill":"#43936f","key":1})]);
}

Success.defaultProps = {"id":"Icon_-_Success","data-name":"Icon - Success","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Success;

Success.default = Success;
